<template>
    <v-container fluid class="pa-3" v-if="sessionActive">

        <material-header
            title="Redemptions"
            help="redemptions"
            info="View and approve redemptions"
            icon="mdi-wallet-giftcard">
        </material-header>

        <v-alert
            tile
            v-show="!hasPermission(minPermission)"
            class="body-2"
            type="error"
        >
            Your user account doesn't have sufficient permissions to use this feature
        </v-alert>

        <v-tabs v-if="hasPermission(minPermission)"
                v-model="activeTab"
                dark
                slider-color="primary"
                color="white"
                @change="tabChanged"
        >

            <v-tab class="ml-3" key="tab1">Approvals</v-tab>
            <v-tab key="tab2">History</v-tab>

            <v-tab-item key="tab1">
                <approvals-tab></approvals-tab>
            </v-tab-item>

            <v-tab-item key="tab2">
                <history-tab :key="'history_' + historyId"></history-tab>
            </v-tab-item>

        </v-tabs>

    </v-container>
</template>

<script>

import Json from 'vue-json-pretty';
import Store from '../store';
import activeSessionChecker from '../../../components/mixins/activeSessionCheckerMixin';
import MaterialHeader from '../../../components/UI/MaterialHeader';
import {timeDisplay} from "../../../components/mixins/timeDisplayMixin";
import ApprovalsTab from "./ApprovalsTab";
import HistoryTab from "./HistoryTab";

const vuexModule = 'Redemptions';

export default {

    mixins: [activeSessionChecker, timeDisplay],

    components: {
        Json,
        MaterialHeader,
        ApprovalsTab,
        HistoryTab
    },

    data() {
        return {
            minPermission: 'view redemptions',
            activeTab: 0,
            warningVisible: true,
            historyId: 1,
        }
    },

    methods: {

        tabChanged(tab) {

            // Force vue to recreate component (with new data)
            if (tab === 1) {
                this.historyId++;
            }
        }
    },

    created() {
        if (!this.$store.state[vuexModule]) {
            this.$store.registerModule(vuexModule, Store);
        }
    }
}

</script>
